import React from 'react';
import ModuleEditOptionsSection from "../ModuleEditOptionsSection";
import { RoofInfoTableKey } from '../../../../../Constants';
import RoofInformationTable
    from "../../../../../components/Layout-Components/Editor-Layout/Popout-Window/Production-Calculation-Popout/Production-Calculation-Popout-Tabs/RoofInformationTable";

const RoofInformationTabIpad: React.FC = () => {

    return (
        <div className='tab__inner'>
            <ModuleEditOptionsSection/>
            <div className='tab__column'>
                <span className='tab__column--title'>Roof Information</span>
                <div className={"roofInformationTableinSidebarContainer"}>
                    <RoofInformationTable shortened={true}/>
                </div>
                <ul className='tab__data--list' style={{width: "500px"}}>
                    {RoofInfoTableKey.map((item) => (
                        <li>
                            <span>{item.short} = {item.long}</span>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
}

export default RoofInformationTabIpad;